<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Claims
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-billing-filter (searchEvent)="onSearch($event)" [filterFields]="fields"></ppl-billing-filter>
                </div>
                <div class="table-style">
                    @if(showTable){
                    <ppl-list-table rowDataAccessibilityKey="referral_participant_id" [disableSort]="true"
                        [disableSearch]="true" [showCustomSearch]="false" [pageConfig]="programName" [sharedDataKey]="sharedDataKey" (rowDetailEvent)="rowClicked($event)" [disableSelection]="true"
                        [loadPage]="true" [pagination]="true" [columnsToBeHidden]="columnsToBeHidden"
                        [actionsToBeHidden]="actionsToBeHidden" [jsonList]="'list_claims'">
                    </ppl-list-table>
                    }
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>